var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconStarHomeCenter = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 8.5L12 4l7 4.5V20H5V8.5z",
  fill: "#F96506"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.609 8.86a.75.75 0 00.782 1.28l.859-.525V19.4c0 .746.604 1.35 1.35 1.35h12.8a1.35 1.35 0 001.35-1.35V9.615l.859.525a.75.75 0 00.782-1.28l-9-5.5a.75.75 0 00-.782 0l-9 5.5zm15.641-.162L12 4.88l-6.25 3.82V19.25h12.5V8.698z",
  fill: "#F96506"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M16 12.28a2.28 2.28 0 01-.662 1.606c-.976.984-1.923 2.01-2.936 2.958a.597.597 0 01-.822-.017l-2.918-2.94a2.281 2.281 0 010-3.214 2.277 2.277 0 013.232 0l.106.107.106-.107A2.277 2.277 0 0116 12.28z",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/icon-star-home-center.917971ecf3122cf921c0116e389ddd69.svg";
export { SvgIconStarHomeCenter as ReactComponent };